import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Blog APIs
//TODO: Blog APIs
//  Blog Create
export const addBlogAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}add-blog`, data, headers);
};
//  Blog List
export const listBlogAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-blog`, headers);
}; 
//  Blog Update
export const updateBlogAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}update-blog`, data, headers);
};
//! Video Article APIs
//TODO: Video Article APIs
//  Video Article Create
export const addVideoArticleAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}add-video-article`, data, headers);
};
//  Video Article List
export const listVideoArticleAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-video-article`, headers);
}; 
//  Video Article Update
export const updateVideoArticleAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}update-video-article`, data, headers);
};